import { render, staticRenderFns } from "./BaseAuthForm.vue?vue&type=template&id=6f68f40c&scoped=true"
import script from "./BaseAuthForm.vue?vue&type=script&lang=js"
export * from "./BaseAuthForm.vue?vue&type=script&lang=js"
import style0 from "./BaseAuthForm.vue?vue&type=style&index=0&id=6f68f40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68f40c",
  null
  
)

export default component.exports